import * as React from 'react';

import { CombinedPerformancesViewProps } from '../../components/list/performances';
import ListPerformance from '../../components/list/performance';

const ListPerformancesView: React.StatelessComponent<CombinedPerformancesViewProps> = props => {

    return (
        <>
            <ul className="stack-md space-top-md stack-border border-top">
                {props.settings.numberOfPerformancesToDisplayByDefault > 0 ?
                    <>
                        {
                            props.filteredPerformances.slice(0, props.settings.numberOfPerformancesToDisplayByDefault)
                                .map(perf => <ListPerformance showReserveButton={props.showReserveButton} allowReserve={props.allowReserve} key={perf.performanceId} performance={perf} />)
                        }
                        {
                            props.showAllPerformances ?
                                props.filteredPerformances.slice(props.settings.numberOfPerformancesToDisplayByDefault, props.filteredPerformances.length)
                                    .map(perf => <ListPerformance showReserveButton={props.showReserveButton} allowReserve={props.allowReserve} key={perf.performanceId} performance={perf} />)
                                : null
                        }
                    </>
                    :
                    props.filteredPerformances.map(perf => <ListPerformance showReserveButton={props.showReserveButton} allowReserve={props.allowReserve} key={perf.performanceId} performance={perf} />)
                }
            </ul>

            {
                props.settings.numberOfPerformancesToDisplayByDefault > 0 && props.filteredPerformances.length > props.settings.numberOfPerformancesToDisplayByDefault && !props.showAllPerformances ?
                    <button className="btn-outline" onClick={props.toggleShowAllPerformances}>{props.text.loadMorePerformancesButtonText}</button>
                    : null
            }

        </>
    );
}

export default ListPerformancesView;